<div class="segments-toolbar">
  <!-- Search Input -->
  <div class="search-container">
    <div class="search-input">
      <div class="search-icon">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.5 11.5C9.26142 11.5 11.5 9.26142 11.5 6.5C11.5 3.73858 9.26142 1.5 6.5 1.5C3.73858 1.5 1.5 3.73858 1.5 6.5C1.5 9.26142 3.73858 11.5 6.5 11.5Z" stroke="#A7ABB3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12.5 12.5L10 10" stroke="#A7ABB3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <input 
        type="text" 
        [value]="searchTerm"
        (input)="onSearchChange($event)"
        class="search-field"
      />
      <div 
        *ngIf="searchTerm" 
        class="clear-icon"
        (click)="clearSearch()"
      >
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="#A7ABB3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  </div>

  <!-- Right Controls -->
  <!-- <div class="toolbar-controls">
 
     <div  class="location-dropdown" (document:click)="onDocumentClick($event)">
      <button class="location-button" (click)="toggleLocationDropdown()">
        <span class="location-text">{{ getSelectedLocationLabel() }}</span>
        <div class="chevron-icon" [class.rotated]="isLocationDropdownOpen">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.28033 7.38033L10 12.0996L14.7197 7.38033" stroke="#15172E" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </button>
      
      <div class="dropdown-menu" [class.open]="isLocationDropdownOpen">
        <div class="dropdown-header">
          <div class="header-title">Location</div>
          
        </div>
        
        <div class="location-list">
          <div 
            *ngFor="let location of locations; trackBy: trackById"
            class="location-item"
            (click)="onLocationToggle(location.value)"
          >
            <div class="checkbox" [class.checked]="isLocationSelected(location.value)">
              <svg *ngIf="isLocationSelected(location.value)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 3L4.5 8.5L2 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span class="location-label">{{ location.label }}</span>
          </div>
        </div>
        
        <div class="dropdown-actions">
          <button class="action-link" (click)="onLocationClear()">Clear</button>
          <div class="action-buttons">
            <button class="btn btn-secondary" (click)="onLocationCancel()">Cancel</button>
            <button class="btn btn-primary" (click)="onLocationApply()">Apply</button>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</div>
